import {
    addSubscription,
    removeSubscription,
    getSubscriptionsCount,
    notifySubscribers,
    createSubscriptionCache,
    SubscriptionsCache,
} from './subscriptions';
import type { TaskSubscriptionData } from '../schema/TaskSubscriptionData';
import { poll, cancelPoll } from 'owa-request-manager';

const POLLING_INTERVAL = 10 * 60 * 1000; // 10 minutes in milliseconds
const RELOAD_TASKS_POLLING_ID = 'RELOAD_TASKS';
let subCache: SubscriptionsCache<void>;

export function subscribePolling(
    subscriptionId: string,
    subscriptionData: TaskSubscriptionData<void>
) {
    if (!subCache) {
        subCache = createSubscriptionCache<void>();
    }
    addSubscription<void>(subCache, subscriptionId, subscriptionData);
    poll(() => notifySubscribers(subCache, undefined), RELOAD_TASKS_POLLING_ID, POLLING_INTERVAL);
}

export function unSubscribePolling(subscriptionId: string) {
    if (!subCache) {
        return;
    }
    // remove from the subscriptions list
    removeSubscription(subCache, subscriptionId);

    // if there are not subscriptions in the list, stop polling
    if (getSubscriptionsCount(subCache) === 0) {
        cancelPoll(RELOAD_TASKS_POLLING_ID);
    }
}
